/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hb-1-ac.reducer';

export const Hb1acDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hb1acEntity = useAppSelector(state => state.hb1ac.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hb1acDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hb1ac.detail.title">Hb1ac</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hb1ac.id">Id</Translate>
            </span>
          </dt>
          <dd>{hb1acEntity.id}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hb1ac.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hb1acEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hb1ac.active">Active</Translate>
            </span>
          </dt>
          <dd>{hb1acEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="tinyMedicRestApp.hb1ac.created">Created</Translate>
            </span>
          </dt>
          <dd>{hb1acEntity.created ? <TextFormat value={hb1acEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hb1ac.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{hb1acEntity.microSec}</dd>
          <dt>
            <span id="reading">
              <Translate contentKey="tinyMedicRestApp.hb1ac.reading">Reading</Translate>
            </span>
          </dt>
          <dd>{hb1acEntity.reading}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.hb1ac.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{hb1acEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.hb1ac.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{hb1acEntity.lastupdated}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hb1ac.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{hb1acEntity.glucoUser ? hb1acEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hb-1-ac" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hb-1-ac/${hb1acEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default Hb1acDetail;
